<template>
  <div class="katakana">
    <stop-watch ref="stopwatch"></stop-watch>

    <kana-chart character-set='katakana' v-bind:kana='orderedKana'
      @first-kana-selection='onFirstKanaSelection'
      v-on:kana-selected='onKanaChartSelected'></kana-chart>

    <randomized-kana character-set='romaji' v-bind:kana='randomizedKana'
      v-on:kana-selected='onRandomKanaSelected'></randomized-kana>
  </div>
</template>

<script>
import KanaSelectionMixin from '@/components/KanaSelectionMixin';

export default {
  name: 'Katakana',

  mixins: [
    KanaSelectionMixin
  ]
};
</script>

<style lang="less" scoped>
@import (reference) '../styles/variables.less';

.katakana {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media @landscape-tables-phones {
    flex-direction: row;
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Katakana.vue